import { Serialiser } from "hooks/serialisers/types";
import { useQueryParamState } from "hooks/useQueryParamState";

const numberSerialiser: Serialiser<number | null, unknown> = {
  format: (value) => value?.toString() ?? "",
  parse: (text) =>
    text === ""
      ? {
          valid: true,
          value: null,
        }
      : { valid: true, value: Number(text) },
};

export const useNumberQueryParamState = (
  paramName: string,
  defaultValue: number | null
) => {
  return useQueryParamState<number | null, unknown>(
    paramName,
    numberSerialiser,
    defaultValue
  );
};
